/** Barlow — page titles and pricing entered-vs-AI count only. */
export const WIZARD_DISPLAY_FONT_FAMILY = "'Barlow Condensed', 'Inter', sans-serif";

/** Default for wizard step content (overrides app-wide Oxanium from PageContext). */
export const WIZARD_FONT_FAMILY = "'Inter', sans-serif";

export const wizardFontStyle = { fontFamily: WIZARD_FONT_FAMILY };

/** Wizard left sidebar — step nav, logo area, mobile progress. */
export const WIZARD_SIDEBAR_FONT_FAMILY = "'Inter', sans-serif";

export const wizardSidebarFontStyle = { fontFamily: WIZARD_SIDEBAR_FONT_FAMILY };

export const wizardSidebarStepTitleStyle = { fontSize: '0.9rem', color: '#1A2744' };

export const wizardSidebarStepSubtitleStyle = { fontSize: '0.75rem', color: '#ADB5BD' };

export const wizardSidebarBackButtonStyle = {
    color: '#1A2744',
    border: '1px solid rgba(66, 99, 235, 0.25)',
};

/** Main heading on each wizard step (WizardStepLayout). */
export const wizardStepPageTitleStyle = {
    fontFamily: WIZARD_DISPLAY_FONT_FAMILY,
    fontSize: '1.625rem',
    fontWeight: 700,
    letterSpacing: '0.2px',
    color: '#1A1A2E',
};

/** Subheading / description under the step title (WizardStepLayout). */
export const wizardStepPageSubtitleStyle = {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.6,
    color: '#6C757D',
};
